import { IdCodeNameQuery } from "../../models/base.query";

export class UnitQuery extends IdCodeNameQuery {
  PhysicalDimensionClv: string;
  RoundingFactor?: number;
  get DisplayName(): string {
    return `${this.Name} (${this.Code})`;
  }

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'RoundingFactor', 'PhysicalDimensionClv'];
  }
}

